module.exports = __webpack_public_path__ + "static/media/suntrans.bbcd18f0.png";